import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { BsSearch } from "react-icons/bs";
import { ImCross } from "react-icons/im";
import { Box, Button, TextField, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import provinces from "@doncicuto/es-provinces";
import { ordenarProvinciasYMunicipios } from "../../functions/ordenarListas";

const FiltrosOficinas = ({ onFilter, clearFilter, filtrosIniciales }) => {
  const { t } = useTranslation('common');
  const [busqueda, setBusqueda] = useState(filtrosIniciales);

  const clearAllFilters = () => {
    if (typeof clearFilter === "function") {
      clearFilter();
    }
    setBusqueda({});
  };

  function handleChange(evt) {
    const value = evt.target.value;
    setBusqueda({
      ...busqueda,
      [evt.target.name]: value,
    });
  }

  const getBusqueda = () => {
    for (let key in busqueda) {
      if (
        busqueda[key] === "" ||
        busqueda[key] === null ||
        busqueda[key] === undefined
      ) {
        delete busqueda[key];
      }
    }
    onFilter(busqueda);
  };

  return (
    <>
      <div className="buscadorFiltros">
        <div style={{ width: "100%" }}>
          <Box mx={1} display={"block"} flexDirection={"row"} gap={2}>
            <TextField
              id="razonSocial-input"
              label={t('filters.businessName')}
              variant="outlined"
              name="razonSocial"
              className="filtros altura"
              value={busqueda.razonSocial || ""}
              onChange={handleChange}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{
                "aria-label": "controlled",
              }}
            />
            {/* <TextField
              id="nif-input"
              label="NIF"
              variant="outlined"
              name="nif"
              className="filtros altura"
              value={busqueda.nif || ""}
              onChange={handleChange}
              onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              inputProps={{
                "aria-label": "controlled",
              }}
            /> */}
            <FormControl variant="outlined" className="filtros-select">
              <InputLabel id="provincia-label">{t('filters.province')}</InputLabel>
              <Select
                labelId="provincia-label"
                id="provincia-select"
                label={t('filters.province')}
                name="provincia"
                className="filtros"
                value={busqueda.provincia || ""}
                onChange={handleChange}
                onKeyPress={(e) => (e.key === "Enter" ? getBusqueda() : "")}
              >
                <MenuItem value="" style={{ height: 40 }}></MenuItem>
                {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                  return (
                    <MenuItem key={i} value={e.name}>
                      {e.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Box>
        </div>
        <div>
          <Button className="btn-buscador" onClick={clearAllFilters}>
            <ImCross />
          </Button>
        </div>
        <div>
          <Button className="btn-buscador" onClick={() => getBusqueda()}>
            <BsSearch />
          </Button>
        </div>
      </div>

      <style jsx="true">
        {`
          .btn-buscador {
            padding: 5px 10px;
            color: #ffffff;
            background-color: #92004d;
            border-radius: 4px;
            font-weight: bold;
            width: -moz-fit-content;
            width: fit-content;
            align-self: flex-end;
            border: none;
            min-width: 40px;
            height: 40px;
            margin: 5px 10px 5px;
          }
          .btn-buscador:hover {
            color: black;
            background-color: #dee2e6;
          }
        `}
      </style>
    </>
  );
};

export default FiltrosOficinas;
